package kz.dentalcrm.app.screens.appointments.add

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.animateContentSize
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshots.SnapshotStateList
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import co.touchlab.kermit.Logger
import compose.icons.FeatherIcons
import compose.icons.feathericons.ChevronLeft
import compose.icons.feathericons.User
import compose.icons.feathericons.X
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.add
import dentalcrm.composeapp.generated.resources.add_appointment
import dentalcrm.composeapp.generated.resources.add_patient
import dentalcrm.composeapp.generated.resources.add_title_optional
import dentalcrm.composeapp.generated.resources.appointment_date
import dentalcrm.composeapp.generated.resources.at
import dentalcrm.composeapp.generated.resources.choose_date_of_appointment
import dentalcrm.composeapp.generated.resources.done
import dentalcrm.composeapp.generated.resources.find_patient
import dentalcrm.composeapp.generated.resources.month_eight_short
import dentalcrm.composeapp.generated.resources.month_eleven_short
import dentalcrm.composeapp.generated.resources.month_five_short
import dentalcrm.composeapp.generated.resources.month_four_short
import dentalcrm.composeapp.generated.resources.month_nine_short
import dentalcrm.composeapp.generated.resources.month_one_short
import dentalcrm.composeapp.generated.resources.month_seven_short
import dentalcrm.composeapp.generated.resources.month_six_short
import dentalcrm.composeapp.generated.resources.month_ten_short
import dentalcrm.composeapp.generated.resources.month_three_short
import dentalcrm.composeapp.generated.resources.month_twelve_short
import dentalcrm.composeapp.generated.resources.month_two_short
import dentalcrm.composeapp.generated.resources.pick_doctor
import dentalcrm.composeapp.generated.resources.or_separator
import dentalcrm.composeapp.generated.resources.pick_patient
import dentalcrm.composeapp.generated.resources.title
import kotlinx.coroutines.flow.collect
import kotlinx.coroutines.flow.onEach
import kotlinx.datetime.LocalDateTime
import kz.dentalcrm.app.core.utils.pad
import kz.dentalcrm.app.core.ui.ScreenState
import kz.dentalcrm.app.core.ui.UiStateScaffold
import kz.dentalcrm.app.core.ui.components.ContentButton
import kz.dentalcrm.app.core.ui.components.UIButton
import kz.dentalcrm.app.core.ui.components.UIIconBackButton
import kz.dentalcrm.app.core.ui.components.UISelfTextInput
import kz.dentalcrm.app.core.ui.components.UITextInputClickable
import kz.dentalcrm.app.expectations.rememberContactPickerState
import kz.dentalcrm.app.screens.appointments.add.mvi.AddAppointmentViewEvent
import kz.dentalcrm.app.screens.appointments.add.mvi.AddAppointmentViewSideEffect
import kz.dentalcrm.app.screens.appointments.add.mvi.AddAppointmentViewState
import kz.dentalcrm.app.screens.appointments.add.mvi.AddAppointmentViewState.Step
import kz.dentalcrm.app.screens.appointments.getWeekDay
import kz.dentalcrm.app.screens.patients.PatientItem
import kz.dentalcrm.app.screens.patients.add.AddPatientDialog
import kz.dentalcrm.app.screens.ui.ContentHeader
import kz.dentalcrm.app.theme.DefaultTheme
import kz.dentalcrm.app.core.ui.components.AppointmentDateTimeDialog
import org.jetbrains.compose.resources.getString
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import kotlin.time.ExperimentalTime
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid
import kz.dentalcrm.app.navigation.AppNavigator
import org.koin.compose.koinInject

@OptIn(ExperimentalTime::class, ExperimentalUuidApi::class)
@Composable
fun AddAppointmentScreen(
    
) {
    val navigator: AppNavigator = koinInject()
    var key by rememberSaveable { mutableStateOf(Uuid.random().toHexString()) }
    val viewModel: AddAppointmentViewModel = koinViewModel(key = key)
    val event: (AddAppointmentViewEvent) -> Unit = viewModel::setEvent

    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        val state by viewModel.viewState.collectAsState()
        var addPatientDialog by remember { mutableStateOf(false) }
        if (addPatientDialog) {
            AddPatientDialog(
                onAdd = { patient ->
                    patient?.let {
                        event.invoke(AddAppointmentViewEvent.SelectPatient(patient))
                    }
                    addPatientDialog = false
                },
                onDismiss = {
                    addPatientDialog = false
                }
            )
        }

        val contactPicker = rememberContactPickerState {}

        val contactSelected by contactPicker.value

        LaunchedEffect(contactSelected) {
            contactSelected?.phoneNumbers?.first().orEmpty().takeIf { it.isNotEmpty() }?.let {
                event(AddAppointmentViewEvent.SearchPatient(it))
            }
        }

        var dateTimeSelect by remember { mutableStateOf(false) }

        LaunchedEffect(
            "screen_launch"
        ) {
            viewModel.effect.onEach {
                when (it) {
                    AddAppointmentViewSideEffect.NavigateBack -> navigator.navigateUp()
                }
            }.collect()
        }

        if (dateTimeSelect) {
            AppointmentDateTimeDialog(
                startDateTime = null,
                onDismissRequest = { dateTimeSelect = false },
                onDateSelected = { dateTime ->
                    event.invoke(AddAppointmentViewEvent.SelectDateTime(dateTime))
                    dateTimeSelect = false
                }
            )
        }

        UiStateScaffold(
            modifier = Modifier.fillMaxSize(),
            isLoading = state.screenState is ScreenState.Loading
        ) {
            Column(
                modifier = Modifier.fillMaxSize()
                    .statusBarsPadding()
            ) {
                ContentHeader(
                    modifier = Modifier.fillMaxWidth()
                        .padding(horizontal = 12.dp),
                    text = stringResource(Res.string.add_appointment),
                    leadingContent = {
                        UIIconBackButton(
                            onClick = navigator::navigateUp
                        )
                    }
                )
                Box(
                    modifier = Modifier.weight(1f)
                ) {
                    LazyColumn(
                        modifier = Modifier.fillMaxSize()
                            .padding(horizontal = 16.dp)
                            .animateContentSize()
                    ) {
                        item(key = "patient_step") {
                            Column(
                                modifier = Modifier.animateItem()
                            ) {
                                Spacer(modifier = Modifier.height(24.dp))
                                HeaderStep(
                                    title = stringResource(Res.string.pick_patient),
                                    position = 1
                                )
                                Spacer(modifier = Modifier.height(4.dp))
                                UISelfTextInput(
                                    modifier = Modifier.fillMaxWidth(),
                                    label = stringResource(Res.string.find_patient),
                                    value = state.searchPatientInput.value,
                                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Done).copy(
                                        keyboardType = KeyboardType.Text
                                    ),
                                    trailingIcon = FeatherIcons.User,
                                    trailingActionClear = false,
                                    trailingIconClicked = {
                                        contactPicker.launchContactPicker()
                                    },
                                    valueChanged = {
                                        event.invoke(AddAppointmentViewEvent.SearchPatient(it))
                                    }
                                )
                                Spacer(modifier = Modifier.height(8.dp))
                                if (state.suggestedPatients.isNotEmpty()) {
                                    Spacer(modifier = Modifier.height(8.dp))
                                }
                            }
                        }
                        state.selectedPatient?.let {
                            item("selected_patient") {
                                Row(
                                    modifier = Modifier.animateItem(),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    PatientItem(
                                        modifier = Modifier.weight(1f),
                                        item = it
                                    ) {
                                        event.invoke(AddAppointmentViewEvent.SelectPatient(it))
                                    }
                                    Spacer(
                                        modifier = Modifier.width(8.dp)
                                    )
                                    ContentButton(
                                        modifier = Modifier.size(56.dp),
                                        shape = RoundedCornerShape(16.dp),
                                        onClick = {
                                            event.invoke(
                                                AddAppointmentViewEvent.RemovePatient(patient = it)
                                            )
                                        }
                                    ) {
                                        Box(
                                            modifier = Modifier.fillMaxSize()
                                                .background(
                                                    color = DefaultTheme.colors.error,
                                                    shape = RoundedCornerShape(16.dp)
                                                ),
                                            contentAlignment = Alignment.Center
                                        ) {
                                            Icon(
                                                imageVector = FeatherIcons.X,
                                                contentDescription = null,
                                                tint = DefaultTheme.colors.onPrimary,
                                                modifier = Modifier.size(24.dp)
                                            )
                                        }
                                    }
                                }
                            }

                        } ?: run {
                            items(items = state.suggestedPatients, key = { it.id }) {
                                PatientItem(
                                    modifier = Modifier.animateItem(),
                                    item = it
                                ) {
                                    event.invoke(AddAppointmentViewEvent.SelectPatient(it))
                                }
                            }
                            item(key = "patient_step_alter") {
                                Column(
                                    modifier = Modifier.animateItem()
                                ) {
                                    Text(
                                        modifier = Modifier.fillMaxWidth(),
                                        style = DefaultTheme.typography.labelRegular,
                                        textAlign = TextAlign.Center,
                                        color = DefaultTheme.colors.onSurfaceVariant,
                                        text = stringResource(Res.string.or_separator)
                                    )
                                    Spacer(modifier = Modifier.height(8.dp))
                                    UIButton(
                                        text = stringResource(Res.string.add_patient),
                                        onClick = {
                                            addPatientDialog = true
                                        }
                                    )
                                    Spacer(modifier = Modifier.height(8.dp))
                                }

                            }
                        }

                        item(key = "time_step") {
                            Column {
                                AnimatedVisibility(
                                    visible = state.step != Step.First,
                                    enter = slideInVertically(tween(300)) { it / 2 } + fadeIn(tween(300)),
                                    exit = slideOutVertically(tween(200)) { it / 2 } + fadeOut(tween(200))
                                ) {
                                    Column {
                                        Spacer(modifier = Modifier.height(16.dp))
                                        HeaderStep(
                                            title = stringResource(Res.string.appointment_date),
                                            position = 2
                                        )
                                        Spacer(modifier = Modifier.height(8.dp))
                                        UITextInputClickable(
                                            modifier = Modifier.fillMaxWidth(),
                                            label = stringResource(Res.string.choose_date_of_appointment),
                                            defaultValue = state.dateFormatted ?: "",
                                            valueChanged = { },
                                            onClicked = {
                                                dateTimeSelect = true
                                            }
                                        )
                                        Spacer(modifier = Modifier.height(8.dp))
                                    }
                                }
                            }
                        }
                        item(key = "appointment_step") {
                            Column {
                                AnimatedVisibility(
                                    visible = state.step == Step.Third || state.step == Step.Fourth,
                                    enter = slideInVertically(tween(300)) { it / 2 } + fadeIn(tween(300)),
                                    exit = slideOutVertically(tween(200)) { it / 2 } + fadeOut(tween(200))
                                ) {
                                    Column {
                                        Spacer(modifier = Modifier.height(16.dp))
                                        HeaderStep(
                                            title = stringResource(Res.string.pick_doctor),
                                            position = 3
                                        )
                                        FlowRow(
                                            modifier = Modifier.fillMaxWidth(),
                                            horizontalArrangement = Arrangement.spacedBy(8.dp),
                                            verticalArrangement = Arrangement.spacedBy(8.dp),
                                            maxItemsInEachRow = 2,
                                        ) {
                                            state.employees.forEach {
                                                Box(
                                                    modifier = Modifier
                                                        .clip(
                                                            shape = RoundedCornerShape(16.dp)
                                                        )
                                                        .background(
                                                            color = if (it.selected) {
                                                                DefaultTheme.colors.primary
                                                            } else {
                                                                DefaultTheme.colors.surfaceAlternative
                                                            },
                                                            shape = RoundedCornerShape(16.dp)
                                                        ).padding(horizontal = 16.dp, vertical = 8.dp)
                                                        .clickable {
                                                            event.invoke(
                                                                AddAppointmentViewEvent.SelectEmployee(
                                                                    it.data
                                                                )
                                                            )
                                                        }
                                                ) {
                                                    Text(
                                                        text = "${it.data.surname} ${it.data.name?.firstOrNull()}.${
                                                            if (it.data.patronymic.isNullOrEmpty()) {
                                                                ""
                                                            } else {
                                                                "${it.data.patronymic.firstOrNull()}."
                                                            }
                                                        }",
                                                        style = DefaultTheme.typography.bodyMediumMedium,
                                                        color =
                                                            if (it.selected) {
                                                                DefaultTheme.colors.onPrimary
                                                            } else {
                                                                DefaultTheme.colors.onSurface
                                                            }
                                                    )
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        item(key = "title_step") {
                            Column {
                                AnimatedVisibility(
                                    visible = state.step == Step.Fourth,
                                    enter = slideInVertically(tween(300)) { it / 2 } + fadeIn(tween(300)),
                                    exit = slideOutVertically(tween(200)) { it / 2 } + fadeOut(tween(200))
                                ) {
                                    Column {
                                        Spacer(modifier = Modifier.height(16.dp))
                                        HeaderStep(
                                            title = stringResource(Res.string.add_title_optional),
                                            position = 4
                                        )
                                        UISelfTextInput(
                                            modifier = Modifier.fillMaxWidth(),
                                            label = stringResource(Res.string.title),
                                            value = state.titleInput.value,
                                            keyboardOptions = KeyboardOptions(imeAction = ImeAction.Done).copy(
                                                keyboardType = KeyboardType.Text
                                            ),
                                            valueChanged = {
                                                event.invoke(AddAppointmentViewEvent.TitleChanged(it))
                                            }
                                        )
                                    }
                                }
                            }
                        }
                        item("confirm") {
                            Column {
                                AnimatedVisibility(
                                    visible = state.step == Step.Fourth,
                                    enter = slideInVertically(tween(300)) { it / 2 } + fadeIn(tween(300)),
                                    exit = slideOutVertically(tween(200)) { it / 2 } + fadeOut(tween(200))
                                ) {
                                    Column {
                                        Spacer(modifier = Modifier.height(24.dp))
                                        UIButton(
                                            text = stringResource(Res.string.add),
                                            isLoading = state.appointmentState is AddAppointmentViewState.AddAppointmentState.Loading,
                                            enabled = state.enableCreateAppointment,
                                            onClick = {
                                                if (state.appointmentState is AddAppointmentViewState.AddAppointmentState.Idle) {
                                                    event.invoke(AddAppointmentViewEvent.CreateAppointment)
                                                }
                                            }
                                        )
                                    }
                                }
                            }
                        }
                        item("footer") {
                            Box(
                                modifier = Modifier.height(56.dp)
                                    .navigationBarsPadding()
                            )
                        }
                    }
                    Text(
                        text = "",
                        modifier = Modifier.align(Alignment.Center),
                        textAlign = TextAlign.Center,
                        style = DefaultTheme.typography.bodyLargeMedium
                    )
                }
            }
        }

    }
}

@Composable
fun HeaderStep(
    title: String,
    position: Int
) {
    Row(
        modifier = Modifier.height(44.dp)
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Start
    ) {
        Box(
            modifier = Modifier.size(24.dp)
                .background(
                    color = DefaultTheme.colors.primary,
                    shape = RoundedCornerShape(32.dp)
                ),
            contentAlignment = Alignment.Center,
        ) {
            Text(
                text = "$position",
                style = DefaultTheme.typography.labelMedium,
                color = DefaultTheme.colors.onPrimary
            )
        }
        Spacer(modifier = Modifier.width(12.dp))
        Text(
            text = title,
            style = DefaultTheme.typography.bodySmallMedium,
            color = DefaultTheme.colors.onSurface
        )
    }
}

@Composable
fun LocalDateTime.formatDateReadable(): String {
    val months = listOf(
        stringResource(Res.string.month_one_short),
        stringResource(Res.string.month_two_short),
        stringResource(Res.string.month_three_short),
        stringResource(Res.string.month_four_short),
        stringResource(Res.string.month_five_short),
        stringResource(Res.string.month_six_short),
        stringResource(Res.string.month_seven_short),
        stringResource(Res.string.month_eight_short),
        stringResource(Res.string.month_nine_short),
        stringResource(Res.string.month_ten_short),
        stringResource(Res.string.month_eleven_short),
        stringResource(Res.string.month_twelve_short),
    )
    val at = stringResource(Res.string.at)
    val dateTime = this
    val weekDay = dateTime.dayOfWeek.ordinal.getWeekDay()
    return "${dateTime.day} ${months[dateTime.month.ordinal]}, ${dateTime.hour}:${dateTime.minute.pad()} ($weekDay)"
}
